<template>
    <div class="mx-4">
        <v-menu offset-x>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                    <v-icon left>mdi-content-copy</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="(item, index) in items" :key="index" @click="copyToClipboard(item)">
                    <v-list-item-title>{{ item.displayName }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import ConceptsStore from "../../concepts-store";

export default {
    name: "AttributesToClipBtn",

    props: {
        attributeValues: Object,
        attributesNames: Object,
    },

    data() {
        return {
            SEPARATOR: " | ",
        }
    },

    computed: {
        items() {
            //copy only one attribute
            let items = Object.keys(this.attributesNames).map(key => {
                return {
                    displayName: this.getItemName([this.attributesNames[key]]),
                    attributesKeys: [key],
                }
            })

            //copy two or all of the attributes
            items.push(
                {
                    displayName: this.getItemName([this.attributesNames.uri, this.attributesNames.notation, this.attributesNames.label]),
                    attributesKeys: ["uri", "notation", "label"],
                },
                {
                    displayName: this.getItemName([this.attributesNames.notation, this.attributesNames.label]),
                    attributesKeys: ["notation", "label"],
                }
            )

            return items;
        },
    },

    methods: {
        getItemName(items) {
            let itemName = "Copier : "
            for (let i = 0; i < items.length; i++) {
                itemName += items[i];
                if (i !== items.length - 1) {
                    itemName += this.SEPARATOR;
                }
            }
            return itemName;
        },

        copyToClipboard(item) {
            let text = "";
            item.attributesKeys.forEach((key, i) => {
                // Copier une chaine vide au lieu de rien en cas d'absence de l'attribut
                if (this.attributeValues[key].length == 0) {
                    text += " ";
                } else {
                    text += this.attributeValues[key];
                }
                // Ajouter le séparateur si besoin
                if (i !== item.attributesKeys.length - 1) {
                    text += this.SEPARATOR;
                }
            })
            this.copyTextToClipboard(text);
        },

        /**
         * Copy text to clipboard
         * 
         * we are using this deprecated method because the new one doesn't work on all browsers
         * the new one is : navigator.clipboard.writeText(text) and permissions are needed
         * 
         * @param {string} text
         */
        copyTextToClipboard(text) {
            let input = document.createElement("input");
            input.value = text;
            document.body.appendChild(input);
            input.style.position = 'fixed'; //avoid scrolling to bottom
            input.style.bottom = 0;
            input.style.left = 0;
            input.focus();
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);

            //display success message in snackbar
            const data = {
                message: "Donnée copiée",
                color: "success",
                icon: "mdi-check-circle-outline"
            }
            ConceptsStore.setConceptSnackbar(data);
        }
    }
}

</script>